<template>
  <div class="emp-tareo">
    <div class="emp-tareo__container">
      <div class="emp-tareo__info">
        <div class="emp-tareo__info-head">
          <div class="emp-tareo__info-user">
            <img :src="data.img || require('@/assets/img/boy.svg')" alt />
          </div>
          <div class="emp-tareo__info-resumen">
            <div class="emp-tareo__info-input">
              TOTAL DÍAS:
              <input type="text" readonly :value="totalDays" />
            </div>
            <div class="emp-tareo__info-input">
              DÍAS TRABAJADOS:
              <input type="text" readonly :value="$store.getters.monthReport.assistance" />
            </div>
            <div class="emp-tareo__info-input" v-if="$store.getters.monthReport.vacation">
              VACACIONES:
              <input type="text" readonly :value="$store.getters.monthReport.vacation" />
            </div>
            <div class="emp-tareo__info-input" v-if="$store.getters.monthReport.medicalBreak">
              DESCANSO MÉDICO:
              <input type="text" readonly :value="$store.getters.monthReport.medicalBreak" />
            </div>
            <div class="emp-tareo__info-input" v-if="$store.getters.monthReport.absence">
              AUSENCIAS:
              <input type="text" readonly :value="$store.getters.monthReport.absence" />
            </div>
            <div class="emp-tareo__info-input" v-if="$store.getters.monthReport.excusedAbsence">
              AUSENCIAS JUSTIFICADAS:
              <input type="text" readonly :value="$store.getters.monthReport.excusedAbsence" />
            </div>
            <div class="emp-tareo__info-input" v-if="$store.getters.monthReport.medicalBreakSubsidized">
              DESCANSO SUBSIDIADO:
              <input type="text" readonly :value="$store.getters.monthReport.medicalBreakSubsidized" />
            </div>
          </div>
        </div>
        <div class="emp-tareo__horas">
          <div class="emp-tareo__horas-dia">
            <div class="emp-tareo__horas-title">HORAS DIURNAS:</div>
            <div class="emp-tareo__horas-body">
              <div class="emp-tareo__horas-input">
                Simples
                <input type="text" readonly :value="simpleHoursComp" />
              </div>
              <div class="emp-tareo__horas-input">
                Tardanzas
                <!-- <input type="text" readonly :value="simpleHoursComp" /> -->
                <md-button class="md-primary md-raised" @click="setTardiness">Agregar</md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="emp-tareo__calendar">
        <v-date-picker :value="null" is-inline :attributes="attrs" :formats="formats" @input="setDayTareo"
          :themeStyles="themeStyle" mode="range" @update:fromPage="monthChange" :drag-attribute="selectDragAttribute"
          @update:toPage="monthChange">
        </v-date-picker>
      </div>
    </div>

    <div class="emp-tareo__legends">
      <div class="emp-tareo__category" v-for="(daySt, $index) of dayStatus" :key="`category-${$index}`">
        <h6>{{ daySt.category }}</h6>
        <div class="emp-tareo__legend-wrap">
          <div class="emp-tareo__legend" v-for="(stat, $indexSt) of daySt.status" :key="`status-${$indexSt}`">
            <span class="dot-legend" :class="`dot-legend--${stat.color}`"></span>
            <span class="emp-tareo__legend-type">{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <SetTareo v-if="dateDayTareo" :dateDay="dateDayTareo" @close-comp="
      dateDayTareo = null;
    dataReport = null;
    " :dataReport="dataReport" :today="attrs[0].dates" @updateAnnualReport="updateAnnualReport" />
    <md-dialog :md-active.sync="openModalTardiness" :md-backdrop="false">
      <md-dialog-title>Tardanzas (en minutos)</md-dialog-title>
      <md-content>
        <div class="tardiness-content">
          <md-field class="field-tardiness" v-for="day in workedDays" :key="day.id">
            <label :for="day.id">{{ day.date }}</label>
            <md-input class="input-tardiness" v-model.number="day.value" :id="day.id"></md-input>
          </md-field>
        </div>
      </md-content>
      <md-dialog-actions>
        <md-button class="md-secundary" @click="openModalTardiness = false">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click="updateTardiness">Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions } from "vuex";

const colors = {
  absence: "#ef476f",
  assistance: "#2cc0d5",
  "licence-payed": "#85C1E9",
  "licence-unpayed": "#17A589",
  "licence-paternity": "#777777",
  death: "#000000",
  "temporary-disability": "#d8ff00",
  "si-maternity-prepost": "#d8ff00",
  "sp-maternity-prepost": "#d8ff00",
  "excused-absence": "#d939cd",
  "vacation": "#93c737",
  "medical-break": "#f9de5c"
};
export default {
  props: {
    value: Object,
  },
  components: {
    SetTareo: () => import("@/components/empleado/SetTareo"),
  },
  async created() {
    console.log("value: ", this.value);

    this.data = this.value;
    console.log(this.data);

    // this.attrs[0].dates = new Date(this.data.report.date);
    await this.updateAnnualReport();
    // if (res.status == 200) {
    //   this.simpleHours = this.$store.getters.monthlySimpleHours(val.month);
    // }
  },
  data() {
    return {
      data: {},
      dates: null,
      anualReport: [],
      monthHolidays: [],
      formats: {
        weekdays: "WW",
      },
      //setting tareo individualmente
      dateDayTareo: null,
      dataReport: null, //objeto de reporte diario,
      simpleHours: 0,
      actualDate: new Date(),
      dayStatus: [
        {
          category: "DÍAS LABORADOS",
          status: [
            {
              color: "blue",
              label: "Asistencia",
              value: "assistance",
            },
            {
              color: "true-red",
              label: "Feriado",
              value: "holiday",
            },
            {
              color: "fuchsia",
              label: "Ausencia justificada",
              value: "excused-absence",
            },
          ],
        },
        {
          category: "DIAS NO LABORADOS Y NO SUBSIDIADOS",
          status: [
            {
              value: "absence",
              label: "S.P. Falta No Justificada",
              color: "red",
            },
            {
              value: "licence-unpayed",
              label:
                "S.P. Permiso o licencia concedidos por el empleador sin goce de haber",
              color: "true-green",
            },
            {
              value: "medical-break",
              label: "S.I. Enfermedad o Accidente (primeros 20 días)",
              color: "yellow",
            },
            {
              value: "vacation",
              label: "S.I. Descanso Vacacional",
              color: "green",
            },
            {
              value: "licence-payed",
              label: "S.I. Licencia u otros motivos con goce de haber",
              color: "true-blue",
            },
            {
              value: "licence-paternity",
              label: "Días Licencia por Paternidad",
              color: "gray",
            },
            {
              value: "death",
              label: "Fallecimiento Padres, Cónyuge o Hijos.",
              color: "black",
            },
          ],
        },
        {
          category: "DIAS SUBSIDIADOS",
          status: [
            {
              value: "temporary-disability",
              label: "S.I - Incapacidad Temporal (Invalidez, enfermedad y accidente)",
              color: "orange",
            },
            {
              value: "si-maternity-prepost",
              label: "S.I - Maternidad - Pre y Post Natal",
              color: "orange",
            },
            {
              value: "sp-maternity-prepost",
              label: "S.P - Maternidad - Pre y Post Natal.",
              color: "orange",
            },
          ],
        },
      ],
      attributesAux: [],
      openModalTardiness: false,
      tardiness: {},
      monthDate: new Date()
    };
  },
  computed: {
    themeStyle() {
      return {
        wrapper: {
          // transform: 'scale(1.4)'
        },
        weekdays: {
          textTransform: "uppercase",
          fontWeight: "bold",
        },
        headerTitle: {
          textTransform: "capitalize",
        },
        dayContent: (params) => ({
          ...(params.isHovered && {
            backgroundColor: "rgba(255, 117, 16, 0.2)",
          }),
        }),
      };
    },
    holidays() {
      if (!this.monthHolidays.length) return [];
      return this.monthHolidays.map((ho) => {
        let date = ho.date.split("-");
        return {
          key: `holiday - ${ho.name}`,
          dates: new Date(
            Number(date[2]),
            Number(date[1]) - 1,
            Number(date[0])
          ).toISOString(),
          dot: {
            backgroundColor: "#ff0000",
            // strokeColor: "#ffffff"
          },
          popover: {
            label: ho.name,
            visibility: "hover",
          },
        };
      });
    },
    attrs() {
      return [{
        key: 'today',
        dates: new Date().toISOString(),
        contentStyle: {
          color: "#97c2c9 !important",
          fontWeight: "bold",
        },
        highlight: true,
      }, ...this.attributesAux, ...this.holidays,];
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: "none",
        },
      };
    },
    totalDays() {
      return this.getDaysInMonth(this.actualDate);
    },
    simpleHoursComp() {
      return this.simpleHours;
    },
    statusLabels() {
      return this.dayStatus.map(cat => {
        return cat.status
      }).reduce((total, status) => total.concat(status), []).map(status => {
        return {
          key: status.value,
          value: status.label
        }
      })
    },
    statusLabelsMap() {
      return new Map(this.statusLabels.map(obj => {
        return [obj.key, obj.value]
      }))
    },
    workedDays() {
      return this.anualReport.filter(report => dayjs(report.date).month() === dayjs(this.monthDate).startOf('month').month() && report.status === 'assistance').map(report => {
        return {
          id: report.id,
          date: dayjs(report.date).format("DD/MM/YYYY"),
          value: report.tardiness || 0
        }
      })
    },
    testAux() {
      return [this.attributesAux[this.attributesAux.length - 1], this.attributesAux.length > 1 ? this.attributesAux[this.attributesAux.length - 2] : ""]
    }

  },
  methods: {
    ...mapActions({
      getAnnualReport: "getEmployeeReport",
    }),
    setDayTareo(val) {
      console.log("hola", val);
      this.dateDayTareo = val;
      this.dates = val;
      // console.log((val.end.getTime()-val.start.getTime())/(1000*3600*24))

      if (val.end.toISOString() == val.start.toISOString()) {
        // console.log('son iguales')
        // this.dataReport = this.anualReport.filter(r => new Date(r.date).getDate() == val.start.getDate() && new Date(r.date).getMonth() == val.start.getMonth())
        this.dataReport = this.anualReport.filter(
          (r) => r.date == val.end.toISOString()
        )[0]
          ? this.anualReport.filter((r) => r.date == val.end.toISOString())[0]
          : {
            contractual: 0,
            diurnal1: 0,
            diurnal2: 0,
            nocturnal1: 0,
            nocturnal2: 0,
            extraHours: 0,
            status: "none",
            employee: this.data.id,
          };
        // console.log(this.dataReport, this.anualReport)
      } else {
        this.dataReport = {
          status: "none",
          employee: this.data.id,
        };
      }
    },
    async updateAnnualReport() {
      console.log(this.dates);

      await this.getAnnualReport({
        id: this.data.id,
        year: this.dates
          ? new Date(this.dates.end).getFullYear()
          : new Date().getFullYear(),
        month: this.dates ? new Date(this.dates.end).getMonth() : new Date().getMonth(),
      }).then((r) => {
        if (r.status < 400) {
          // console.log('Reporte anual obtenido',r.data)
          this.simpleHours = this.$store.getters.monthlySimpleHours(
            this.dates ? new Date(this.dates.end).getMonth() : new Date().getMonth() + 1
          );
          this.anualReport = r.data.detail;
          this.monthHolidays = r.data.holidayList;
          this.attributesAux = []
          this.anualReport.forEach((obj) => {
            const register = {
              dates: new Date(obj.date).toISOString(),
              dotName: obj.status,
              dot: {
                backgroundColor: obj.status != "holiday" ? colors[obj.status] : "#ffffff",
              },
              popover: {
                label: obj.tardiness > 0 ? 'Tardanza' : obj.status != "holiday" ? this.statusLabelsMap.get(obj.status) : "",
                visibility: obj.status != "holiday" ? "hover" : "none",
              }
            };
            this.attributesAux.push(register);
            if (obj.tardiness > 0) {
              const register = {
                dot: {
                  backgroundColor: '#ff7b00',
                },
                dates: new Date(obj.date).toISOString(),
              }
              this.attributesAux.push(register);
            }
          });
        }
      });
    },
    monthChange(val) {
      console.log(val);
      if (val) {
        this.monthDate = dayjs().month(val.month-1).year(val.year).endOf("month").format()
        console.log(this.monthDate);
        this.getAnnualReport({
          id: this.data.id,
          year: val.year,
          month: val.month - 1,
        }).then((r) => {
          if (r.status == 200) {
            // console.log('Reporte anual obtenido',r.data)
            this.anualReport = r.data.detail;
            this.monthHolidays = r.data.holidayList;
            let strAux = val;
            console.log(strAux);
            this.actualDate = dayjs().month(val.month-1).year(val.year).endOf("month").toDate();
            this.simpleHours = this.$store.getters.monthlySimpleHours(val.month, val.year);
            console.log(this.simpleHours);
            this.attributesAux = []
            this.anualReport.forEach((obj) => {
              const register = {
                dates: new Date(obj.date).toISOString(),
                dotName: obj.status,
                dot: {
                  backgroundColor: obj.status != "holiday" ? colors[obj.status] : "#ffffff",
                },
                popover: {
                  label: obj.tardiness > 0 ? 'Tardanza' : obj.status != "holiday" ? this.statusLabelsMap.get(obj.status) : "",
                  visibility: obj.status != "holiday" ? "hover" : "none",
                }
              };
              this.attributesAux.push(register);
              if (obj.tardiness > 0) {
                const register = {
                  dot: {
                    backgroundColor: '#ff7b00',
                  },
                  dates: new Date(obj.date).toISOString(),
                }
                this.attributesAux.push(register);
              }
            });
          }
        });
      }
    },
    getDaysInMonth(date) {
      console.log(date);
      
      let dateAux = dayjs(date).endOf("month").get("date");
      
      return dateAux;
    },
    setTardiness() {
      this.openModalTardiness = true;
    },
    updateTardiness() {
      const payload = {
        id: this.$store.state.business.businessId,
        body: {
          list: this.workedDays.map(dayreport => {
            return {
              dayreportId: dayreport.id,
              value: dayreport.value
            }
          })
        }
      }

      this.$store.dispatch("setTardiness", payload).then(res => {
        console.log(res);
        if (res.status === 200) {
          this.$toasted.success(`Tardanza actualizada`, {
            theme: "bubble",
            position: "top-right",
            duration: 5000,
            className: "short-message"
          });
        }
      }).catch(err => {
        this.$toasted.error(`Error al actualizar la tardanza`, {
          theme: "bubble",
          position: "top-right",
          duration: 5000,
          className: "short-message"
        });
      }).finally(() => {
        this.openModalTardiness = false;
      })
    }
  },
};
</script>

<style lang="scss">
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;

.c-header {
  color: $b-emph;
}

.c-weekdays {
  height: 3rem;
  background: #e9e9f0;
}

.c-weekday {
  color: rgba($b-blue, 0.5);
}

// .c-day-content{
//   &:hover{
//     background-color: rgba($b-orange,.2) !important;

//   }
// }</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}

//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
.c-pane-container {
  background-color: #fff !important;
  border: none !important;
  border-radius: 9px;
  transform-origin: top;
  width: 256px;
  transform: scale(calc(21 * 14 / 256));

  @include mq($sm) {
    transform: scale(calc(24 * 14 / 256));
  }

  @include mq($md) {
    transform: scale(calc(24 * 15 / 256));
  }

  @include mq("1290px") {
    transform-origin: top left;
    transform: scale(calc(24 * 15.3 / 256));
  }

  // @include mq("1351px") {
  //   transform: scale(calc(29.1 * 15.3 / 256));
  // }
}

.c-header {
  color: $b-emph !important;
}

.c-day-content {
  &:hover {
    background-color: $b-orange !important;
  }
}

//slot!!!
.day-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.8rem;
  height: 1.8rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1;
  border-radius: 50%;
  transition: all 0.18s ease-in-out;
  margin: 0.1rem 0.08rem;
  cursor: pointer;

  &:hover {
    background-color: rgba($b-orange, 0.2);
  }
}

.emp-tareo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 45rem;
  background-color: #eceff8;
  padding-bottom: 3rem;

  // z-index: 9;
  &__container {
    display: flex;
    flex-direction: column;

    @include mq($sm) {
      align-items: center;
    }

    @include mq("1290px") {
      flex-direction: row;
      flex-wrap: wrap;
      padding-left: 1.5rem;
      align-items: flex-start;
    }
  }

  &__info {
    @include mq($sm) {
      width: 37.5rem;
    }

    &-head {
      display: flex;
      flex-direction: column;
      align-items: center;

      @include mq($sm) {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    &-user {
      height: 12rem;
      background: #fff;
      width: 12rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 9px;

      img {
        height: 9rem;
      }
    }

    &-resumen {
      background-color: #fff;
      margin-top: 1.5rem;
      width: 21rem;
      height: 12rem;
      padding: 1rem;
      border-radius: 9px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      @include mq($sm) {
        margin: 0;
        padding: 1.5rem 3rem;
        width: 24rem;
      }
    }

    &-input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0;

      input[type="text"] {
        height: 2rem;
        display: block;
        width: 2.4rem;
        border: 1px solid #d7dae2;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        @include mq($sm) {
          width: 3rem;
        }
      }
    }
  }

  &__horas {
    padding: 1rem;
    background-color: #fff;
    margin: 0 auto;
    margin-top: 1.5rem;
    border-radius: 9px;
    width: 21rem;

    @include mq($sm) {
      width: 37.5rem;
      padding: 2rem 4rem;
    }

    @include mq("1290px") {
      padding: 3.5rem 4rem;
    }

    &-body {
      display: flex;
      margin: 0.6rem 0;
    }

    &-input {
      display: flex;
      flex-direction: column;
      width: 12rem;
      margin-right: 1rem;

      input[type="text"] {
        display: block;
        width: 100%;
        height: 2rem;
        border: 1px solid #d7dae2;
        border-radius: 4px;
        text-align: center;
        margin-top: 0.3rem;
      }
    }

    &-title {
      color: $b-emph;
      font-weight: 600;
    }
  }

  &__calendar {
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;

    @include mq("1290px") {
      margin: 0 0 0 1rem;
      padding: 0;
      align-items: flex-start;
    }
  }

  &__legends {
    padding: 1rem;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    margin: 3.5rem auto;
    border-radius: 9px;
    width: 21rem;
    align-items: center;

    @include mq($sm) {
      margin-top: 6.5rem;
      width: 24rem;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: center;
      padding: 1rem;
    }

    @include mq($md) {
      margin-top: 3rem;
    }

    @include mq("1290px") {
      padding: 1rem;
      width: 62.5rem;
      margin: 1.5rem 0 1rem 1.5rem;
      // justify-content: flex-start;
    }

    @include mq("1351px") {
      width: 67.5rem;
    }

    @include mq($xl) {
      width: 66.4rem;
    }
  }

  &__legend {
    width: 13rem;
    display: flex;
    align-items: center;

    // height: 3rem;
    @include mq($sm) {
      width: 11rem;
      line-height: 15px;
    }

    @include mq("1290px") {
      width: auto;
      // height: 2.5rem;
      margin: 1rem;
    }

    @include mq("1351px") {
      margin: 1rem 0.75rem;
    }
  }

  @include mq($md) {
    bottom: 0;
  }

  &__category {
    width: 100%;

    @include mq($md) {
      width: 30%;
    }
  }
}

.dot-legend {
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  margin-right: 1rem;
  flex-shrink: 0;

  @include mq("1290px") {
    margin-right: 0.5rem;
  }

  &--true-red {
    background-color: #ff0000;
  }

  &--black {
    background-color: #000000;
  }

  &--gray {
    background-color: #777777;
  }

  &--true-blue {
    background-color: #85c1e9;
  }

  &--true-green {
    background-color: #17a589;
  }

  &--red {
    background-color: #ef476f;
  }

  &--blue {
    background-color: #2cc0d5;
  }

  &--green {
    background-color: #93c737;
  }

  &--yellow {
    background-color: #f9de5c;
  }

  &--orange {
    background-color: #d8ff00;
  }

  &--purple {
    background-color: #7b1fa2;
  }

  &--fuchsia {
    background-color: #d939cd;
  }
}

.tardiness-content {
  padding: 1rem;
  width: 450px;
  // max-height: 400px;
  display: flex;
  flex-flow: row wrap;
  gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}

.field-tardiness {
  max-width: 70px;
  margin: 4px 0;

  label {
    font-weight: 600;
    color: $b-emph;
  }
}

.input-tardiness {
  width: 100% !important;
}
</style>
